import React from "react";
import { AccountDetailsDrawerType } from "enums/AccountDetailsDrawerType";
import useAccountData from "hooks/useAccountData";
import LoadingWithoutModal from "components/common/LoadingWithoutModal";
import EditAccountDrawer from "components/platform/accounts/EditAccountDrawer";

interface NewAccountDrawerProps {
  open: boolean;
  handleClose: (refresh?: boolean) => void;
  onAfterClose: () => void;
}

/**
 * Adding an account. Mount it on open and unmount it once it has slid out
 * (`useDrawerRecord`), so each open starts from an empty form.
 */
const NewAccountDrawer: React.FC<NewAccountDrawerProps> = ({
  open,
  handleClose,
  onAfterClose,
}) => {
  const { formikAddAccount, isLoading, isSavingAccount } = useAccountData({
    handleClose,
  });

  return (
    <>
      <EditAccountDrawer
        formik={formikAddAccount}
        open={open}
        onAfterClose={onAfterClose}
        handleClose={handleClose}
        drawerType={AccountDetailsDrawerType.NewAccount}
        savingAccount={isSavingAccount}
      />
      <LoadingWithoutModal open={isLoading} />
    </>
  );
};

export default NewAccountDrawer;
